import React from 'react';
import { ArrowRight, HeartPulse, UsersRound } from 'lucide-react';
export function Paths() {
  return <section id="therapy" className="py-24 bg-white scroll-mt-20" data-id="element-154" data-mp="whda5uvfl7ad">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-155" data-mp="rqwvy8jsdhmy">
        <div className="grid lg:grid-cols-[0.85fr_1.15fr] gap-10 lg:gap-16 items-center" data-id="element-156" data-mp="rpdbe5r3kkfd">
          <div data-id="element-157" data-mp="noti5d9na0yi">
            <p className="text-sm font-semibold uppercase tracking-[0.18em] text-accent-500 mb-4" data-id="element-158" data-mp="np30ceog73tn">
              Go deeper, together
            </p>
            <h2 className="text-3xl md:text-4xl font-title font-bold mb-5" data-id="element-159" data-mp="dqm0es7j7evg">
              Insight is a beginning. Therapy is where we put it into practice.
            </h2>
            <p className="text-stone-600 text-lg leading-relaxed mb-8" data-id="element-160" data-mp="4qgw4qxmwwli">
              The Assessment can help you recognize your patterns. Psychotherapy
              gives you a collaborative space to understand where they come from,
              build new tools, and create more satisfying relationships.
            </p>
            <a href="/therapy/individual" className="inline-flex items-center px-6 py-3 bg-accent-500 text-white rounded-full font-semibold hover:bg-accent-600 transition-colors" data-id="element-161" data-mp="16dif92d9o6sx">
              Explore Therapy Services
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-162" data-mp="xfg4vw7n81sz" />
            </a>
          </div>

          <div className="grid sm:grid-cols-2 gap-5" data-id="element-163" data-mp="11f8i4m7zew4o">
            <div className="rounded-3xl bg-accent-50 border border-accent-100 p-8" data-id="element-164" data-mp="1p49kpsu4vd21">
              <div className="w-12 h-12 bg-white rounded-2xl flex items-center justify-center text-accent-500 shadow-sm mb-7" data-id="element-165" data-mp="1u3cqjfhxtnb2">
                <HeartPulse className="h-6 w-6" data-id="element-166" data-mp="1gb6d41665ufb" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-167" data-mp="1kdkvyl9u8u6l">Start with yourself</h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-168" data-mp="1kbgh58aeiarj">
                Individual therapy for more self-knowledge, steadier emotions,
                and clearer relationships.
              </p>
            </div>
            <div className="rounded-3xl bg-brand-800 text-white p-8" data-id="element-169" data-mp="2mpuaww11bmhi">
              <div className="w-12 h-12 bg-white/10 rounded-2xl flex items-center justify-center text-brand-100 mb-7" data-id="element-170" data-mp="2mnzyk63tx2p1">
                <UsersRound className="h-6 w-6" data-id="element-171" data-mp="2dpfr613pyfg4" />
              </div>
              <h3 className="text-xl font-semibold mb-3 text-white" data-id="element-172" data-mp="2dnl5gkkmijaz">Work on connection</h3>
              <p className="text-brand-100 leading-relaxed" data-id="element-173" data-mp="28q32dataeyaw">
                Couples, group, and online psychotherapy rooted in Affect
                Relational Therapy.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}